import Validator from '../validator';

const dateTimeValidator = (type: string, value: string) => {
  switch (value) {
    case 'invalid':
      return `Incorrect ${type}`;
    case 'incomplete':
      return `Incomplete ${type}`;
    default:
      return null;
  }
};

// register all varieties of date & time here
Validator.register('datetime', (value: string) => dateTimeValidator('DateTime', value));
Validator.register('date', (value: string) => dateTimeValidator('Date', value));
Validator.register('time', (value: string) => dateTimeValidator('Time', value));
